module.exports = __webpack_public_path__ + "img/质量管理体系认证证书（英文版）.c38e34cd.jpg";